import type { ObjectSchema } from "yup";
import { boolean, object, string } from "yup";

import type { LoginCredential } from "~/shared/utils/auth-poker-sdk/auth-poker-sdk";

export const createAuthValidationSchema = (t: {
  validation_required: string;
}): ObjectSchema<LoginCredential> => {
  return object({
    nick: string().required(t.validation_required),

    password: string().required(t.validation_required),
    isRememberPassword: boolean().default(false),
  });
};
